import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReferentielState } from './referentiel.state';

export const selectReferentielState =
  createFeatureSelector<ReferentielState>('referentiel');

export const selectLanguages = createSelector(
  selectReferentielState,
  (state) => state.languages
);

export const selectServices = createSelector(
  selectReferentielState,
  (state) => state.services
);

export const selectInsurers = createSelector(
  selectReferentielState,
  (state) => state.insurers
);

export const selectReferentielLoading = createSelector(
  selectReferentielState,
  (state) => state.loading
);

export const selectReferentielError = createSelector(
  selectReferentielState,
  (state) => state.error
);

export const selectCountries = createSelector(
  selectReferentielState,
  (state) => state.countries
);
